import React from "react";
import './style.css'

// 300 × 250
// 300 × 300
// 240 × 400

const YANDEX_TAGS = [
  [
    'R-A-17532372-1',
    'R-A-17532372-2',
    'R-A-17532372-3',
  ],
  [
    'R-A-17532372-4',
    'R-A-17532372-5',
    'R-A-17532372-6',
  ]
]

class IndexPage extends React.Component {
  state = {
    ads: [
      [React.createRef(), React.createRef(), React.createRef()],
      [React.createRef(), React.createRef(), React.createRef()],
    ],
  }

  schedulerRenderAd(j, i, timer) {
    return setTimeout(() => {
      if (this.state.ads[j][i].current) {
        const rerenderN = Number(this.state.ads[j][i].current.dataset.rerender || '0')
        if (rerenderN > 10) return
        this.renderAd(j, i)
      }
    }, timer)
  }

  renderAd(j, i) {
    const slot = this.state.ads[j][i].current
    const rerenderN = Number(slot.dataset.rerender || '0')
    const errorN = Number(slot.dataset.error || '0')

    if (errorN > 3) {
      slot.style.display = 'none'
      return
    }

    slot.dataset.rerender = String(rerenderN + 1)
    const code = YANDEX_TAGS[j][i]
    let timer;
    window.Ya.Context.AdvManager.render({
      async: true,
      blockId: code,
      renderTo: `ad-${j}-${i}`,
      onError: (error) => {
        this.schedulerRenderAd(j, i, 15000)
        slot.dataset.error = String(errorN + 1)
      },
      onClose: () => {
        this.renderAd(j, i)
      },
      onRender: (data) => {
        timer = this.schedulerRenderAd(j, i, 30000)
        slot.dataset.error = '0'
      },
      videoCallbacks: {
        onAdStart: () => {
          clearInterval(timer)
        },
        onAdEnd: () => {
          this.renderAd(j, i)
        },
      },
    }, () => {
      this.schedulerRenderAd(j, i, 15000)
      slot.dataset.error = String(errorN + 1)
    })
  }

  getAdContainerRef = (ref) => {
    if (!ref) return
    const {width} = ref.getBoundingClientRect()
    if (width === 0) {
      this.setState({
        ads: [],
      })
    }

    if (width >= 240 && width < 300) {
      this.setState({
        ads: [
          this.state.ads[0].slice(0, 2),
          this.state.ads[1].slice(0, 2)
        ],
      })
    }
  }

  componentDidMount() {
    return;
    if (window.location.host !== 'updl.ru') return

    setTimeout(() => {
      window.yaContextCb = window.yaContextCb || []
      window.yaContextCb.push(() => {
        this.state.ads.forEach((ads, j) => {
          ads.forEach((ad, i) => {
            this.renderAd(j, i)
          })
        })
      })
    }, 0)
  }

  render() {
    const {children} = this.props;
    const {ads} = this.state;
    const [leftAds = [], rightAds = []] = ads
    return (
      <div className="index-wrapper-window">
        <div className="index-wrapper">
          <div className="index-ad">
            {leftAds.map((ref, i) => (
              <div key={i} id={`ad-0-${i}`} className="index-ad-block -left" ref={ref}/>
            ))}
          </div>
          <div className="index-content container-body">{children}</div>
          <div className="index-ad" ref={this.getAdContainerRef}>
            {rightAds.map((ref, i) => (
              <div key={i} id={`ad-1-${i}`} className="index-ad-block -right" ref={ref}/>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default IndexPage